export default function Logo({ className = '' }) {
  return (
    <img
      src="/assets/logo.png"
      alt="F&L Group"
      className={`h-12 w-auto ${className}`}
      data-testid="fl-logo"
    />
  );
}
